<template>
    <div class="newsdetail">
        <div class="title">
            <p>{{languageType == 0?detailFrom.name:detailFrom.enName}}</p>
            <span>{{detailFrom.addTime}}</span>
        </div>
        <div class="artic">
            <div v-if="languageType == 0" v-html="detailFrom.introduce"></div>
            <div v-else v-html="detailFrom.enIntroduce"></div>
            <div class="pic">
                <img v-for="(item,index) in picList" :key="index" :src="item"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['languageType'],
    data () {
        return {
            detailFrom:{},
            picList:[]
        }
    },
    created () {
        let id = sessionStorage.getItem('detailId')
        this.getDetail(id)
    },
    methods:{
         getDetail (id) {
            this.$http({
                url: this.$http.adornUrl('/web/news/get'),
                method: 'post',
                params: {
                    'id':id,
                }
                }).then(({data}) => {
                   this.detailFrom = data
                    this.picList = data.pics.split(',')
                if (data && data.code === 0) {
                    
                } else {
                    
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
    .newsdetail {
        margin: 0 80px;
        margin-bottom: 90px;
        .title {
            padding-top: 70px;
            padding-bottom: 34px;
            border-bottom: 1px solid #e7e7e7;
            p {
                text-align: left;
                font-size: 28px;
                color: #000000;
            }
            span {
                display: block;
                text-align: left;
                font-size: 14px;
                color: #606060;
                margin-top: 45px;
            }
        }
        .artic {
            padding-top: 50px;
            p {
                text-align: left;
                font-size: 14px;
                line-height: 25px;
            }
            .pic {
                margin-top: 20px;
                padding-bottom: 90px;
                img {
                    width: 1060px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/newsdetail.vue